import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { LoadingWrapper } from '../../../../styles/styled';
import {
  CategoryPopup,
  CategoryBackdrop,
  CategoryPopupContainer,
  CategoryPopupActions,
} from './styled';
import Loading from '../../../../components/Loading';
import { ActionButton, OrangeSubmitButton } from '../../../../components/buttons/buttons';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import CategoryDraggable from './CategoryDraggable';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { reorderInArray } from '../managed/sorting_utils';

import SelectableList from '../shared/SelectableList';
import { isEmpty, range, sample, isEqual, sortBy } from 'lodash';
import Colors from '../../../../styles/colors';
import { STATIC_HOMEPAGE_URL } from '../../../../config';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import { ALERTS } from '../../../../helpers/texts';
import Dialog from 'material-ui/Dialog';

const getDraggableListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "lightblue" : "lightgrey",
});

export default class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      currentCategoryID: '',
      currentCategory: null,
      categories: [],
      individuals: [],
      bundles: [],
      categoryTitle: '',
      title: '',
      slug: '',
      savingCategoryTitle: false,
      loading: false,
      showEditPopup: false,
      editPopupLoading: false,
      showAddPopup: false,
      addPopupLoading: false,
      addPopupError: '',
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Upgrade',
        onClose: () => {},
        upgrade: false,
        dismissible: true,
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const newIds = nextProps.categories.tags.map(
      tag => String(tag.id) + tag.updatedAt + tag.featured
    );
    const previousIds = prevState.categories.map(
      tag => String(tag.id) + tag.updatedAt + tag.featured
    );
    if (nextProps.categories.loading === false && !isEqual(sortBy(newIds), sortBy(previousIds))) {
      return {
        loading: false,
        categories: nextProps.categories.tags,
      };
    }
    // In case categories are loading
    if (nextProps.categories.loading !== prevState.loading) {
      return {
        loading: nextProps.categories.loading,
      };
    }

    const { loading: editLoading, error: editError } = nextProps.categories.editById;
    if (editLoading === false && prevState.editPopupLoading) {
      // If has error just stop loading
      if (editError) {
        return {
          editPopupLoading: false,
        };
      }
      return {
        editPopupLoading: false,
        showEditPopup: false,
      };
    }

    const { loading: addLoading, error: addCategoryError } = nextProps.categories.create;

    if (prevState.addPopupLoading === false && addLoading === true) {
      return {
        addPopupLoading: true,
      };
    }

    if (prevState.addPopupLoading === true && addLoading === false) {
      // When finish adding new category
      if (!nextProps.categories.create.error) {
        nextProps.fetchCategories({
          publisherId: nextProps.userInfo.publisherID,
        });
      }

      return {
        addPopupLoading: false,
        addPopupError: nextProps.categories.create.error,
        showAddPopup: !nextProps.categories.create.error ? false : true, // If has error don't close popup
      };
    }
    return prevState;
  }

  componentDidMount() {
    // If its not a publisher
    if (!this.props.userInfo.publisherID) return;
    // Initializing Call to load Categories
    this.props.fetchCategories({
      publisherId: this.props.userInfo.publisherID,
    });
  }

  onDragEnd = result => {
    // dropped outside the list
      if (!result.destination) {
        return;
      }
      // dropped in the same place
      if (result.source.index === result.destination.index) {
        return;
      }
      const categories = reorderInArray(
        this.state.categories,
        result.source.index,
        result.destination.index
      );

      this.setState({ categories });

      this.props.updatePublisherCategoryOrder({
        publisherId: this.props.userInfo.publisherID,
        categories,
      });
  };

  handleCloseEdit = () => {
    this.setState({
      showEditPopup: false,
      showAddPopup: false,
    });
  };

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      onClose = false,
      dismissible = true,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            dismissible,
            onClose: !show ? false : onClose,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showModal(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  checkPlanTypes = (type = '', alert = {}) => {
    if (!canUserAccessFeature(type)) {
      return this.showModal({
        title: 'Upgrade Required',
        content: alert,
        upgrade: true,
      });
    }
    return true;
  };

  handleAdd = () => {
    if (this.checkPlanTypes('ADD_CATEGORY', ALERTS().ADD_CATEGORY.NO_ACCESS)) {
      this.setState({
        showAddPopup: true,
      });
    }
  };

  handleEdit = categoryId => {
    if (this.checkPlanTypes('EDIT_CATEGORY', ALERTS().EDIT_CATEGORY.NO_ACCESS)) {
      this.setState({
        showEditPopup: true,
        individuals: [],
        bundles: [],
        currentCategoryID: categoryId,
      });
    }
  };

  handleSetAsFeatured = categoryId => {
    if (
      this.checkPlanTypes('SET_AS_FEATURED_CATEGORY', ALERTS().SET_AS_FEATURED_CATEGORY.NO_ACCESS)
    ) {
      this.props.updateTagAsFeaturedCreator({
        categoryId,
        publisherId: this.props.userInfo.publisherID,
      });
    }
  };

  handleClearAsFeatured = categoryId => {
    if (
      this.checkPlanTypes(
        'UNSET_AS_FEATURED_CATEGORY',
        ALERTS().UNSET_AS_FEATURED_CATEGORY.NO_ACCESS
      )
    ) {
      this.setState({
        loading: true,
      });
      this.props.clearTagAsFeaturedCreator({
        categoryId,
        publisherId: this.props.userInfo.publisherID,
      });
    }
  };

  handleSaveCategoryTitle = categoryId => categoryTitle => {
    if (this.checkPlanTypes('EDIT_CATEGORY_TITLE', ALERTS().EDIT_CATEGORY_TITLE.NO_ACCESS)) {
      this.setState({
        savingCategoryTitle: true,
      });
      this.props.updateSoundcastsCategoryTitle({
        categoryId,
        name: categoryTitle,
        publisherId: this.props.userInfo.publisherID,
      });
    }
  };

  onCategoryInputChange = (key = 'title') => {
    return e => {
      const input = e.target.value;
      this.setState({
        [key]: input || '',
      });
    };
  };

  calculateSlugFromTitle = title => {
    if (title.trim().replace(/[^a-zA-Z]/g, '').length === 0) {
      return range(11)
        .map(i => sample('abcdefghijklmnopqrstuvwxyz0123456789'))
        .join('');
    }
    return title
      .replace(/[^a-zA-Z0-9]/g, '-')
      .replace(/--/g, '-')
      .toLowerCase();
  };

  handleAddNew = () => {
    this.props.createPublisherCategory({
      publisherId: this.props.userInfo.publisherID,
      title: this.state.title,
      position: 1,
      slug: this.calculateSlugFromTitle(this.state.title),
    });
  };

  renderAddPopup = () => {
    if (!this.state.showAddPopup) return null;
    return (
      <CategoryPopupContainer>
        <CategoryBackdrop onClick={this.handleCloseEdit} />
        <CategoryPopup>
          {!this.state.addPopupLoading ? (
            <Fragment>
              <div
                className="padding-bottom-20px"
                style={{ display: 'flex', alignItems: 'center' }}>
                <span className="title-medium ">Add Category</span>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="field-title">Title</div>
                  <div className="field-input">
                    <input
                      type="text"
                      placeholder="category title"
                      onChange={this.onCategoryInputChange('title')}
                    />
                  </div>
                </div>
              </div>
              <CategoryPopupActions style={{ marginTop: '10px' }}>
                <button className="btn btn-orange" onClick={this.handleAddNew}>
                  Save
                </button>
                <button className="btn btn-primary" onClick={this.handleCloseEdit}>
                  Cancel
                </button>
              </CategoryPopupActions>
            </Fragment>
          ) : (
            <LoadingWrapper height="90">
              <Loading text="Loading..." />
            </LoadingWrapper>
          )}
        </CategoryPopup>
      </CategoryPopupContainer>
    );
  };

  renderAlertPopup() {
    const { show, title, content, upgrade, dismissible = true, onClose } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.modalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton id="actionButtonTest1" onClick={actionBtnClick}>
          {actionLabel}
        </ActionButton>
        {upgrade && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={() => {
              this.modalHandler({ show: false })();
              if (onClose) {
                onClose();
              }
            }}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={!dismissible}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  handleDelete = categoryId => {
    if (this.checkPlanTypes('DELETE_CATEGORY', ALERTS().DELETE_CATEGORY.NO_ACCESS)) {
      this.props.deletePublisherCategory({
        tagId: categoryId,
        publisherId: this.props.userInfo.publisherID,
      });
    }
  };

  handleClick = (result) => {
    if (result) {
      this.checkPlanTypes( 'EDIT_CATEGORY_TITLE', ALERTS().EDIT_CATEGORY_TITLE.NO_ACCESS);
    }
  }

  isPlanNotPermitted = () => {
   return !canUserAccessFeature('DND_CATEGORIES')
  }

  handleSaveEdit = () => {
    this.setState({
      editPopupLoading: true,
    });

    const { byId } = this.props.categories;
    const categoryInfo = byId[this.state.currentCategoryID.toString()];
    const initialSelectedItems = isEmpty(categoryInfo)
      ? []
      : categoryInfo.map(soundcast => soundcast.soundcastId);
    let selectedItems = [...this.state.individuals];
    selectedItems = selectedItems.concat(this.state.bundles);
    const itemsToDelete = [];
    const itemsToAdd = [];

    // Finding new Items
    selectedItems.forEach(selectedItem => {
      if (!~initialSelectedItems.indexOf(selectedItem)) itemsToAdd.push(selectedItem);
    });

    // Finding Items need to remove
    initialSelectedItems.forEach(selectedItem => {
      if (!~selectedItems.indexOf(selectedItem)) itemsToDelete.push(selectedItem);
    });

    this.props.updateSoundcastsPublisherCategory({
      itemsToAdd,
      itemsToDelete,
      categoryId: this.state.currentCategoryID,
      publisherId: this.props.userInfo.publisherID,
    });
  };

  renderEditPopup = () => {
    if (!this.state.showEditPopup) return null;

    const { individuals, bundles, byId } = this.props.categories;
    const filteredIndividuals = individuals.filter(
      soundcast => soundcast.published && soundcast.landingPage
    );
    const filteredBundles = bundles.filter(
      soundcast => soundcast.published && soundcast.landingPage
    );

    const categoryInfo = byId[this.state.currentCategoryID.toString()];
    const initialSelectedItems = categoryInfo.map(soundcast => soundcast.soundcastId);

    return (
      <CategoryPopupContainer>
        <CategoryBackdrop onClick={this.handleCloseEdit} />
        <CategoryPopup>
          {!this.state.editPopupLoading ? (
            <Fragment>
              <div
                className="padding-bottom-20px"
                style={{ display: 'flex', alignItems: 'center' }}>
                <span className="title-medium ">Edit Category</span>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <SelectableList
                    label="Individual Soundcasts included in category"
                    items={filteredIndividuals}
                    initialSelectedItems={initialSelectedItems}
                    onChange={selectedItems => {
                      this.setState({ individuals: selectedItems });
                    }}
                  />
                </div>
                <div className="col-md-12" style={{ marginTop: '10px' }}>
                  {bundles.length > 0 ? (
                    <SelectableList
                      label="Bundles included in category"
                      items={filteredBundles}
                      initialSelectedItems={initialSelectedItems}
                      onChange={selectedItems => {
                        this.setState({ bundles: selectedItems });
                      }}
                    />
                  ) : (
                    <div />
                  )}
                </div>
              </div>
              <CategoryPopupActions style={{ marginTop: '10px' }}>
                <button className="btn btn-orange" onClick={this.handleSaveEdit}>
                  Save
                </button>
                <button className="btn btn-primary" onClick={this.handleCloseEdit}>
                  Cancel
                </button>
              </CategoryPopupActions>
            </Fragment>
          ) : (
            <LoadingWrapper height="90">
              <Loading text="Loading..." />
            </LoadingWrapper>
          )}
        </CategoryPopup>
      </CategoryPopupContainer>
    );
  };

  render() {
    const { categories = [], loading } = this.state;
    // const { userInfo, history, match } = this.props;

    if (loading) {
      return (
        <LoadingWrapper height="90">
          <Loading text="Loading categories, please wait" />
        </LoadingWrapper>
      );
    }

    return (
      <MuiThemeProvider>
        <div style={{ minHeight: 700 }}>
          <div className="padding-bottom-20px" style={{ display: 'flex', alignItems: 'center' }}>
            <span className="title-medium ">Categories</span>
            <a
              href={`${STATIC_HOMEPAGE_URL}/publishers/${this.props.userInfo.publisherID}`}
              title="View Publisher Page">
              <span className="text-medium" style={{ marginLeft: 15, color: Colors.mainOrange }}>
                <strong>View Publisher Page</strong>
              </span>
            </a>
          </div>
          {this.renderEditPopup()}
          {this.renderAddPopup()}
          {this.renderAlertPopup()}
          <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getDraggableListStyle(snapshot.isDraggingOver)}>
                  {categories.map((category, index) => {
                    const isPlanNotPermitted = this.isPlanNotPermitted();
                    return (
                      <CategoryDraggable
                        key={`category-${category.id}`}
                        index={index}
                        category={category}
                        byId={this.props.categories.byId[`${category.id}`]}
                        onEdit={this.handleEdit}
                        onDelete={this.handleDelete}
                        onSetAsFeatured={this.handleSetAsFeatured}
                        onClearFeatured={this.handleClearAsFeatured}
                        onTitleChange={this.handleSaveCategoryTitle(category.id)}
                        isPlanNotPermitted={isPlanNotPermitted}
                        onClickEdit={this.handleClick}
                      />
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <OrangeSubmitButton
            onClick={this.handleAdd}
            className="text-center"
            label="Add new Category"
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

Categories.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
};
